import { user } from 'services';
import { SimpleSelect } from 'libs/ui';
import { WhiteStyledField, StyledField } from '../fields';
import { required } from '../validation';
import { Place, StyledLabel } from './parking-filter2.styled';

export const ParkingFilter2 = (props) => {
  if (!props.force && !window.config.central) {
    return null;
  }

  const { dark, disabled } = props;

  const parkings = user.getMaps().parking.map((el, idx) => {
    return (
      <option key={idx} value={el.id}>
        {el.name}
      </option>
    );
  });

  if (props.simple) {
    return (
      <Place>
        <StyledLabel>Парковка</StyledLabel>
        <SimpleSelect onChange={props.onChange} width="145px" value={props.current}>
          {props.withEmpty && <option value="">Выберите парковку</option>}
          {parkings}
        </SimpleSelect>
      </Place>
    );
  }

  const Cmp = dark ? StyledField : WhiteStyledField;
  const other = {};
  if (props.required) {
    other.validate = required;
  }

  return (
    <Cmp disabled={disabled} type="select" label="Парковка" defaultValue={props.defaultValue} name="parking_id" {...other}>
      {props.withEmpty && <option value="">Выберите парковку</option>}
      {parkings}
    </Cmp>
  );
};

ParkingFilter2.defaultProps = {
  force: false,
  withEmpty: false,
  disabled: false,
  method: '',
};
